/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, {
  useEffect,
  useState
} from 'react';

import ChatbotIcon from './ChatbotIcon';

import MainlayoutChatbot from 'components/templates/MainlayoutChatbot';
import Chatting from 'components/templates/WSChatting';
import useWebSocket from 'hooks/useWebSocket';
import mapModifiers from 'utils/functions';

type OpenStatusType = 'init' | 'open' | 'close';
type BubbleMsgStatusType = 'init' | 'open' | 'close';

const ChatbotWidget: React.FC = () => {
  const [openStatus, setOpenStatus] = useState<OpenStatusType>('init');
  const [openBubbleMsgStatus, setBubbleMsgStatus] = useState<BubbleMsgStatusType>('init');
  const [isExpand, setIsExpand] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useWebSocket({ isTestAgent: false });

  // useEffect(() => {
  //   const handleMessage = (e: any) => {
  //     if (e.data.message === 'window-resize') {
  //       setIsMobile(e.data.data <= 576);
  //     }
  //   };

  //   window.parent.addEventListener('message', handleMessage);

  //   return () => {
  //     window.parent.removeEventListener('message', handleMessage);
  //   };
  // }, []);

  const detectOpenStatus = () => {
    if (openStatus === 'init') {
      window.parent.postMessage({ type: 'OPEN_IFRAME', open: true }, '*');
      setOpenStatus('open');
    }
    if (openStatus === 'open') {
      window.parent.postMessage({ type: 'OPEN_IFRAME', open: false }, '*');
      window.parent.postMessage({ type: 'BUBBLE_MSG', open: false }, '*');
      setOpenStatus('close');
    }
    if (openStatus === 'close') {
      window.parent.postMessage({ type: 'OPEN_IFRAME', open: true }, '*');
      setOpenStatus('open');
    }
  };

  const detectCloseBubbleMsgStatus = () => {
    if (openBubbleMsgStatus === 'init') {
      window.parent.postMessage({ type: 'BUBBLE_MSG', open: false }, '*');
      setBubbleMsgStatus('close');
    }
  };

  const changeIframeWidth = (newWidth: number) => {
    window.parent.postMessage({ type: 'UPDATE_IFRAME_WIDTH', maxWidth: newWidth }, '*');
  };

  const expendIframe = (isExpanded: boolean) => {
    setIsExpand(isExpanded);
    changeIframeWidth(isExpanded ? 800 : 480);
  };

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'OPEN_IFRAME') {
        if (event.data?.open) {
          window.parent.postMessage({ type: 'OPEN_IFRAME', open: true }, '*');
          setOpenStatus('open');
        } else {
          window.parent.postMessage({ type: 'OPEN_IFRAME', open: false }, '*');
          setOpenStatus('close');
        }
      }
    });
  }, []);

  useEffect(() => {
    window.parent.postMessage({ type: 'OPEN_IFRAME', open: false }, '*');
    window.parent.postMessage({ type: 'BUBBLE_MSG', open: false }, '*');
    setIsMobile(document.body.clientWidth < 480);
    const onResize = () => {
      if (document.body.clientWidth < 480) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <MainlayoutChatbot>
      <div className={mapModifiers('p-chatbotWidget', openStatus !== 'init' && openStatus, isExpand && 'expand', isMobile && 'mobile')}>
        <div className="p-chatbotWidget_wrap">
          <div className="p-chatbotWidget_box">
            <Chatting
              handleToggleExpand={expendIframe}
              handleCloseChatbot={detectOpenStatus}
              chatbotEmbed
            />

          </div>
        </div>
        <ChatbotIcon
          openStatus={openStatus}
          detectOpenStatus={detectOpenStatus}
          detectCloseBubbleMsgStatus={detectCloseBubbleMsgStatus}
          openBubbleMsgStatus={openBubbleMsgStatus}
        />
      </div>
    </MainlayoutChatbot>
  );
};

export default ChatbotWidget;
